export default __webpack_public_path__ + "navigation-camera-geometry-framing-after-maneuver-disabled-1200-4d206bafad00264f3032634c8d913f5b.webp";